module.exports = __webpack_public_path__ + "img/d5.60ed622c.jpg";